import { NormalizedScheduledLeg } from '@mopla/data-models';

export type TEffectiveLegTimes = {
	effectiveStart: string;
	effectiveEnd: string;
};

/** Times to drive by: the estimate, which the BE falls back to the plan for. */
export const getEffectiveLegTimes = (
	leg: NormalizedScheduledLeg
): TEffectiveLegTimes => ({
	effectiveStart: leg.estimatedStart || leg.start || '',
	effectiveEnd: leg.estimatedEnd || leg.end || '',
});
